// extracted by mini-css-extract-plugin
export default {"VideoDiv":"Videos_VideoDiv__5Q10Y"};